import { OntarioObstetricalFileClickableTextContext } from "@/Common/Models/UI/ClickableTextContext";
import { BaseOntarioObstetricalFileSubSection, BaseOntarioObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/Ontario/Subcomponent/BaseOntarioObstetricalFileSubSection";
import { OntarioObstetricalFileFieldLimits } from "@/Patient/Components/MedicalNote/ObstetricalFile/Form/Ontario/OntarioObstetricalFileFieldLimits";

class OntarioObstetricalFilePostnatalHistoryPatientStatus extends BaseOntarioObstetricalFileSubSection<BaseOntarioObstetricalFileSubSectionProps, never> {
    private readonly currentMedicationsId = "PostnatalCurrentMedications";
    private readonly bladderFunctionId = "PostnatalBladderFunction";
    private readonly emotionalWellbeingId = "PostnatalEmotionalWellbeing";
    private readonly bowelFunctionId = "PostnatalBowelFunction";
    private readonly relationshipId = "PostnatalRelationship";
    private readonly sexualFunctionId = "PostnatalSexualFunction";
    private readonly postpartumDepressionScreenId = "PostnatalPostpartumDepressionScreen";
    private readonly lochiaOrMensesId = "PostnatalLochiaOrMenses";
    private readonly familySupportOrCommunityResourcesId = "PostnatalFamilySupportOrCommunityResources";
    private readonly perineumOrIncisionId = "PostnatalPerineumOrIncision";

    public render(): JSX.Element {
        const postNatal = this.props.form.Postnatal;
        const fieldLimits = OntarioObstetricalFileFieldLimits.Page5;

        return (
            <div>
                <div className="row row-form">
                    {this.renderSimpleField(
                        "ObstetricalFile_CurrentMedicationsLabel",
                        this.controlRenderer.renderTextarea({
                            value: postNatal.History.CurrentMedications,
                            onChange: value => this.props.mutateModelState(s => s.Postnatal.History.CurrentMedications = value),
                            maxLength: fieldLimits.Postnatal_CurrentMedications.MaxChars,
                            clickableTextOptions: this.getClickableTextOptions(this.currentMedicationsId, OntarioObstetricalFileClickableTextContext.Postnatal_CurrentMedications),
                            id: this.currentMedicationsId
                        }),
                        "col-md-12"
                    )}
                </div>
                <div className="row row-form">
                    {this.renderSimpleField(
                        "ObstetricalFile_BladderFunctionLabel",
                        this.controlRenderer.renderTextbox({
                            value: postNatal.History.BladderFunction,
                            onChange: value => this.props.mutateModelState(s => s.Postnatal.History.BladderFunction = value),
                            maxLength: fieldLimits.Postnatal_BladderFunction.MaxChars,
                            clickableTextOptions: this.getClickableTextOptions(this.bladderFunctionId, OntarioObstetricalFileClickableTextContext.Postnatal_BladderFunction),
                            id: this.bladderFunctionId
                        }),
                        "col-md-6"
                    )}
                    {this.renderSimpleField(
                        "ObstetricalFile_EmotionalWellbeingLabel",
                        this.controlRenderer.renderTextbox({
                            value: postNatal.History.EmotionalWellbeing,
                            onChange: value => this.props.mutateModelState(s => s.Postnatal.History.EmotionalWellbeing = value),
                            maxLength: fieldLimits.Postnatal_EmotionalWellBeing.MaxChars,
                            clickableTextOptions: this.getClickableTextOptions(this.emotionalWellbeingId, OntarioObstetricalFileClickableTextContext.Postnatal_EmotionalWellbeing),
                            id: this.emotionalWellbeingId
                        }),
                        "col-md-6"
                    )}
                </div>
                <div className="row row-form">
                    {this.renderSimpleField(
                        "ObstetricalFile_BowelFunctionLabel",
                        this.controlRenderer.renderTextbox({
                            value: postNatal.History.BowelFunction,
                            onChange: value => this.props.mutateModelState(s => s.Postnatal.History.BowelFunction = value),
                            maxLength: fieldLimits.Postnatal_BowelFunction.MaxChars,
                            clickableTextOptions: this.getClickableTextOptions(this.bowelFunctionId, OntarioObstetricalFileClickableTextContext.Postnatal_BowelFunction),
                            id: this.bowelFunctionId
                        }),
                        "col-md-6"
                    )}
                    {this.renderSimpleField(
                        "RelationshipLabel",
                        this.controlRenderer.renderTextbox({
                            value: postNatal.History.Relationship,
                            onChange: value => this.props.mutateModelState(s => s.Postnatal.History.Relationship = value),
                            maxLength: fieldLimits.Postnatal_Relationship.MaxChars,
                            clickableTextOptions: this.getClickableTextOptions(this.relationshipId, OntarioObstetricalFileClickableTextContext.Postnatal_Relationship),
                            id: this.relationshipId
                        }),
                        "col-md-6"
                    )}
                </div>
                <div className="row row-form">
                    {this.renderSimpleField(
                        "ObstetricalFile_SexualFunctionLabel",
                        this.controlRenderer.renderTextbox({
                            value: postNatal.History.SexualFunction,
                            onChange: value => this.props.mutateModelState(s => s.Postnatal.History.SexualFunction = value),
                            maxLength: fieldLimits.Postnatal_SexualFunction.MaxChars,
                            clickableTextOptions: this.getClickableTextOptions(this.sexualFunctionId, OntarioObstetricalFileClickableTextContext.Postnatal_SexualFunction),
                            id: this.sexualFunctionId
                        }),
                        "col-md-6"
                    )}
                    {this.renderSimpleField(
                        "ObstetricalFile_PostpartumDepressionScreenLabel",
                        this.controlRenderer.renderTextbox({
                            value: postNatal.History.PostpartumDepressionScreen,
                            onChange: value => this.props.mutateModelState(s => s.Postnatal.History.PostpartumDepressionScreen = value),
                            maxLength: fieldLimits.Postnatal_PostpartumDepressionScreen.MaxChars,
                            clickableTextOptions: this.getClickableTextOptions(this.postpartumDepressionScreenId, OntarioObstetricalFileClickableTextContext.Postnatal_PostpartumDepressionScreen),
                            id: this.postpartumDepressionScreenId
                        }),
                        "col-md-6"
                    )}
                </div>
                <div className="row row-form">
                    {this.renderSimpleField(
                        "ObstetricalFile_LochiaOrMensesLabel",
                        this.controlRenderer.renderTextbox({
                            value: postNatal.History.LochiaOrMenses,
                            onChange: value => this.props.mutateModelState(s => s.Postnatal.History.LochiaOrMenses = value),
                            maxLength: fieldLimits.Postnatal_LochiaOrMenses.MaxChars,
                            clickableTextOptions: this.getClickableTextOptions(this.lochiaOrMensesId, OntarioObstetricalFileClickableTextContext.Postnatal_LochiaMenses),
                            id: this.lochiaOrMensesId
                        }),
                        "col-md-6"
                    )}
                    {this.renderSimpleField(
                        "ObstetricalFile_FamilySupportOrCommunityResourcesLabel",
                        this.controlRenderer.renderTextbox({
                            value: postNatal.History.FamilySupportOrCommunityResources,
                            onChange: value => this.props.mutateModelState(s => s.Postnatal.History.FamilySupportOrCommunityResources = value),
                            maxLength: fieldLimits.Postnatal_FamilySupportOrCommunityResources.MaxChars,
                            clickableTextOptions: this.getClickableTextOptions(this.familySupportOrCommunityResourcesId, OntarioObstetricalFileClickableTextContext.Postnatal_FamilySupport),
                            id: this.familySupportOrCommunityResourcesId
                        }),
                        "col-md-6"
                    )}
                </div>
                <div className="row row-form">
                    {this.renderSimpleField(
                        "ObstetricalFile_PerineumOrIncisionLabel",
                        this.controlRenderer.renderTextbox({
                            value: postNatal.History.PerineumOrIncision,
                            onChange: value => this.props.mutateModelState(s => s.Postnatal.History.PerineumOrIncision = value),
                            maxLength: fieldLimits.Postnatal_PerineumOrIncision.MaxChars,
                            clickableTextOptions: this.getClickableTextOptions(this.perineumOrIncisionId, OntarioObstetricalFileClickableTextContext.Postnatal_PerineumIncision),
                            id: this.perineumOrIncisionId
                        }),
                        "col-md-6"
                    )}
                </div>
            </div>
        );
    }
}

export { OntarioObstetricalFilePostnatalHistoryPatientStatus };
